module.exports = __webpack_public_path__ + "img/16.d722b06d.png";